<template>
    <div>
        <div class="collection-title">
            <div style="display: flex; align-items: center">
                <div class="title-line"></div>
                <span class="title-content">我的自选</span>
                <span class="deadline-text">截至日期 {{ date }}</span>
            </div>
            <div class="fund-search">
                <el-autocomplete
                    v-model="searchText"
                    popper-class="my-autocomplete"
                    placeholder="请输入名称查询"
                    class="input-search"
                    :fetch-suggestions="querySearchAsync"
                    v-on:select="handleSelect"
                >
                    <template slot-scope="{ item }">
                        <div class="name">
                            {{ item.value }}
                        </div>
                    </template>
                    <el-button
                        slot="suffix"
                        icon="el-icon-search"
                        class="search-icon"
                        type="text"
                        size="small"
                        v-on:click="searchFund"
                    />
                </el-autocomplete>
            </div>
        </div>
        <fund-list
            :fund-info="fund"
            :all-page="allPage"
            :is-collection="true"
            :has-load="hasLoad"
            no-fund-msg="暂无自选基金"
            v-on:new-fund="newFund"
            v-on:fund-continue="fundBuy"
        />
    </div>
</template>

<script>
import mixin from "@/assets/js/mixin";
import fundList from "@/components/fund/dcFundList";
import fundApi from "@/api/fund";
import format from "date-fns/format";

export default {
    name: "MyCollection",
    components: {
        fundList
    },
    mixins: [mixin],
    data() {
        return {
            searchText: "", // 搜索文本内容
            fund: [], // 基金信息
            queryFind: null, // 定时器
            allPage: "0", // 所有数据条数
            pagecount: 10, // 分页条数
            pageoffset: 1, // 起始页
            date: "", // 当前日期
            hasLoad: false // 是否已经查询数据
        };
    },
    watch: {
        searchText(val, from) {
            if (from.length > 0 && val == "") {
                this.searchFund();
            }
        }
    },
    created() {},
    mounted() {
        this.date = this.$util.fmtDate(format(new Date(), "YYYYMMDD"));
        // this.doAction()
    },
    methods: {
        // 获取新一页数据
        newFund(val) {
            this.pageoffset = val;
            this.doAction();
        },
        // 对基金频繁查询请求做处理
        doAction(val, cb) {
            const _this = this;
            if (cb) {
                val = this.$util.filterCode(val);
                this.searchText = val;
                if (val.length < 1) {
                    cb.call(this, []);
                    return false;
                }
            }
            clearTimeout(this.queryFind);
            this.queryFind = setTimeout(function () {
                _this.getFund(val, cb);
            }, 500);
        },
        // 获取关注基金信息
        async getFund(val, cb) {
            const _this = this;
            const _x = {
                keyword: val || (this.searchText ? this.searchText : ""),
                pagesize: cb ? 20 : this.pagecount,
                pagenum: val ? 1 : this.pageoffset
            };
            const res = await fundApi.qryCollectFund(_x);
            _this.hasLoad = true;
            if (!val) {
                if (this.pageoffset == 1) {
                    this.allPage = "0";
                }
            }
            if (res.data) {
                if (!val) {
                    _this.fund = res.data.list;
                }
                if (!cb) {
                    _this.allPage = res.data.total.toString();
                } else {
                    cb.call(_this, res.data.list);
                }
            }
        },
        // 搜索基金
        searchFund() {
            this.pageoffset = 1;
            this.doAction(this.searchText);
        },
        // 获取下拉列表数据
        querySearchAsync(queryString, cb) {
            this.pageoffset = 1;
            this.doAction(queryString, (res) => {
                let _cbArr = [];
                res.forEach((item, index) => {
                    let _x = {};
                    _x.value = item.fundname + "(" + item.fundcode + ")";
                    _x.id = item.fundcode;
                    _x.index = index;
                    _cbArr.push(_x);
                });
                cb(_cbArr);
            });
        },
        // 选中建议项
        handleSelect() {
            if (this.searchText.indexOf("(") != -1) {
                this.searchText = this.searchText.slice(0, this.searchText.indexOf("("));
            }
            this.pageoffset = 1;
            this.doAction();
        },
        // 处理基金适当性信息
        fundBuy(way, val) {
            // 处理购买现金宝基金跳转
            if (this.xjbCode && this.xjbCode.indexOf(val.fundcode) > -1 && way === "20,22") {
                this.$router.push({ name: "currencycharge", query: { fundcode: val.fundcode } });
                return;
            }
            // 普通购买/定投
            let _url = "";
            if (way === "20,22") {
                _url = "buyfund";
                val.proto = "buy";
            } else if (way === "59") {
                _url = "generalbuy";
                val.proto = "plan";
            }
            this.$util.fundRiskCheck(this, val, (res) => {
                if (res) {
                    const _x = Object.assign({}, res, { way: way });
                    sessionStorage.setItem(_url, JSON.stringify(_x));
                    this.$router.push({ name: _url, query: { fundcode: res.fundcode } });
                }
            });
        }
    }
};
</script>

<style lang="scss" scoped>
@import "../../assets/css/varibles";
.collection-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 0 0 15px 0;
    .deadline-text {
        font-size: 14px;
        color: #999999;
        line-height: 25px;
    }
    .fund-search {
        padding: 5px 0;
        .input-search {
            width: 350px;
            vertical-align: middle;
            .search-icon {
                margin: 3px 5px;
                color: #666666;
            }
            .el-input__inner {
                height: 40px;
                border-bottom-right-radius: 0;
                border-top-right-radius: 0;
            }
            .el-input-group__append {
                background-color: $color-a;
                color: $text-color6;
                font-size: $f20;
                border-color: $color-a;
                padding: 0 10px;
            }
        }
    }
    .el-button--text {
        font-size: 14px;
        font-weight: normal;
    }
}
</style>
